module.exports = __webpack_public_path__ + "img/f9f89acebb4b2adae8d377bd5cfdb2fd.png";